import './preloader.css'

const Preloader = () => {
    return (
        <div className="preloader">
            <div className="loader">
                <div className="loader-outter"></div>
                <div className="loader-inner"></div>
                <span>WSA</span>
            </div>
        </div>
    )
}

export default Preloader